module.exports = __webpack_public_path__ + "static/media/cq.ccadc220.png";